import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7dpvor9hnj: FaireBrandEntity = {
  token: "b_7dpvor9hnj",
  type: "brand",
  name: "Case-Mate",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9403037df4da6455fd18d59eac5711d833cbe170248ed8cd15ca8ed780e5112.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/34d479a670c4fb3f411e21e3658557cc8cef8195b452084c1e3b49ff86e74c01.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e9403037df4da6455fd18d59eac5711d833cbe170248ed8cd15ca8ed780e5112.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/34d479a670c4fb3f411e21e3658557cc8cef8195b452084c1e3b49ff86e74c01.png",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 273,
  isTopShop: true,
  isInsider: true,
  description:
    "Case-Mate has spent the past two decades setting the standard for stylish innovation, evolving from fashion-forward phone cases into a curated line of award-winning accessories, including bestselling Jelly Tote beach bags. Our Jelly Tote Collection—featured in Oprah Daily, Good Housekeeping, Travel + Leisure, and more—offers a variety of silhouettes, colors, and materials that are lightweight, packable, and washable, designed to elevate every beach day and getaway.\n\nAs part of our partnership, we maintain a MAP policy to ensure consistent pricing across all retailers. All products purchased through Faire should be resold at or above the MSRP listed on each product page (Manufacturer’s Suggested Retail Price in the U.S. and Canada). While you’re always welcome to price above MSRP, we ask that pricing does not fall below it.\n\nAdditionally, all social selling must take place through public-facing social media channels. Private Facebook groups and other private selling platforms or methods are not permitted.\n\nOur products may also not be listed or resold on third-party marketplaces, including but not limited to Amazon, Walmart, eBay, Etsy, Poshmark, Cratejoy, WhatNot, TikTok Shop, private Facebook groups, or similar marketplace platforms.\n\nAdditional information regarding our policy can be found here:\nhttps://case-mate.com/pages/mappolicy",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:34.445Z",
    importedBy: "entity-db-cli",
  },
};
